module.exports = __webpack_public_path__ + "img/mon_256.3b658067.png";